export enum AppointmentTypeModalityEnum {
  Presencial = 1,
  Teleconsulta = 2,
}
